import type { IconData } from '@stacksjs/iconify-core'

export const parachuteDrop: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\"><path stroke-linejoin=\"round\" d=\"M11.025 41.11c.16 2.093 1.827 3.602 3.923 3.703c2.01.097 4.938.187 8.9.187s6.889-.09 8.899-.187c2.096-.101 3.763-1.61 3.924-3.703c.1-1.3.177-2.992.177-5.11s-.078-3.81-.177-5.11c-.16-2.093-1.828-3.602-3.924-3.703c-2.01-.097-4.937-.187-8.9-.187c-3.961 0-6.888.09-8.899.187c-2.096.101-3.763 1.61-3.923 3.703a67 67 0 0 0-.177 5.11c0 2.118.077 3.81.177 5.11Z\"/><path stroke-linecap=\"round\" d=\"M30.848 39h-6m6-5h-3M24 18v9M3 18c6 5 21 9 21 9m21-9c-6 5-21 9-21 9\"/><path stroke-linejoin=\"round\" d=\"M3 18c0-6 7-15 21-15s21 9 21 15c0 0-4-3-11-3s-10 3-10 3s-3-3-10-3s-11 3-11 3Z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default parachuteDrop
